export interface Message {
  id: string;
  role: 'user' | 'agent';
  content: string;
  agentEmoji?: string;
}

interface ChatMessageProps {
  message: Message;
  onCopy: (content: string) => void;
  onInsert: (content: string) => void;
}

export function ChatMessage({ message, onCopy, onInsert }: ChatMessageProps) {
  const isAgent = message.role === 'agent';

  return (
    <div className={`chat-message ${isAgent ? 'chat-message-agent' : 'chat-message-user'}`}>
      {isAgent && (
        <span className="chat-message-avatar">{message.agentEmoji || '\u{1F916}'}</span>
      )}
      <div className="chat-message-body">
        <div className="chat-message-content">{message.content}</div>
        {isAgent && (
          <div className="chat-message-actions">
            <button
              className="chat-action-btn"
              onClick={() => onCopy(message.content)}
              title="Copy to clipboard"
            >
              Copy
            </button>
            <button
              className="chat-action-btn"
              onClick={() => onInsert(message.content)}
              title="Insert at cursor"
            >
              Insert
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
